const RoundGabon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
      <g>
        <path
          fill="#FFDA2C"
          d="M31.0048 21.5651C31.648 19.8319 32 17.9571 32 16C32 14.0428 31.648 12.1681 31.0048 10.4348L16 9.04346L0.995188 10.4348C0.352063 12.1681 0 14.0428 0 16C0 17.9571 0.352063 19.8319 0.995188 21.5651L16 22.9565L31.0048 21.5651Z"
        />
        <path
          fill="#1A47B8"
          d="M16 32C22.8794 32 28.7441 27.658 31.0047 21.5652H0.995117C3.25587 27.658 9.12049 32 16 32Z"
        />
        <path fill="#6DA544" d="M16 0C9.12049 0 3.25587 4.342 0.995117 10.4348H31.0048C28.7441 4.342 22.8794 0 16 0Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="white" d="M0 0H32V32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RoundGabon;
